var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconReservationGraphics = function SvgIconReservationGraphics(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Grupo 5669",
    width: 50,
    height: 41.259,
    viewBox: "0 0 50 41.259",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 1984",
    fill: "#4b4b4b",
    d: "M0 0h50v41.259H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 5668",
    clipPath: "url(#a)",
    fill: "#4b4b4b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 4569",
    d: "M45.28 23.233a1.141 1.141 0 0 0 .087-.076l4.324-4.628a1.15 1.15 0 1 0-1.68-1.571l-2.288 2.449A20.7 20.7 0 0 0 26.901.005a1.15 1.15 0 1 0-.205 2.291 18.388 18.388 0 0 1 16.742 17.481l-2.422-2.263a1.15 1.15 0 0 0-1.57 1.681l4.3 4.018a1.159 1.159 0 0 0 1.537.019c.02-.017.006-.005 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 4570",
    d: "M39.999 6.733c0 .005 0 0 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 4571",
    d: "m37.984 33.684-.028.028.015-.015.013-.013"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 4572",
    d: "M23.3 38.963h-.019c-4.21-.378-.648-.059-.021 0a18.385 18.385 0 0 1-16.7-17.476l2.422 2.263a1.15 1.15 0 0 0 1.571-1.68l-4.3-4.018a1.168 1.168 0 0 0-1.625.055L.31 22.734a1.15 1.15 0 0 0-.043 1.521 1.127 1.127 0 0 0 .1.1 1.15 1.15 0 0 0 1.625-.055l2.29-2.45A20.692 20.692 0 0 0 23.1 41.254a1.15 1.15 0 1 0 .2-2.29"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 4573",
    d: "m24.633 21.716.014.009a.8.8 0 0 0 .079.044l3.6 2.078a1.048 1.048 0 1 0 1.052-1.812l-3.167-1.834v-3.363a1.054 1.054 0 0 0-.776-1.015l-.009-.037h-.267a1.053 1.053 0 0 0-1.052 1.052v3.971a1.038 1.038 0 0 0 .525.905"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 4574",
    d: "M25.16 30.03a9.219 9.219 0 1 0-9.219-9.219 9.229 9.229 0 0 0 9.219 9.219m0-16.334a7.116 7.116 0 1 1-7.116 7.116 7.124 7.124 0 0 1 7.116-7.116"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconReservationGraphics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-reservation-graphics.fec6fffa.svg";
export { ForwardRef as ReactComponent };